// extracted by mini-css-extract-plugin
export default {"error":"ErrorBoundary_error__QseL9"};